
export const myproject = [
    {
      id: 1,
      img: "https://i.ibb.co/5TQrpGW/ecommerce.png",
      link: "https://emart-dynamic-ecommerce-app.onrender.com/",
    },
    {
      id: 2,
      img: "https://i.ibb.co/KmmZRpW/job-Finder.png",
      link: "https://job-finder-app-xf86.onrender.com/",
    },
    {
      id: 3,
      img: "https://i.ibb.co/JmxnWBr/moviflix.png",
      link: "https://movieflix-app-pearl.vercel.app/",
    },
    {
      id: 4,
      img: "https://i.ibb.co/tmPH30F/crypto-Verse.png",
      link: "https://cryptoverse-reactapp.vercel.app/",
    },
    {
      id: 5,
      img: "https://i.ibb.co/drZscQZ/remote-editor.png",
      link: "https://realtime-remote-sync-editor.onrender.com/",
    },
    {
      id: 6,
      img: "https://i.ibb.co/tq35SLq/nitish-kumar-portfolio.png",
      link: "https://nitishkumarportfolio.vercel.app/",
    },
  ];